module.exports = __webpack_public_path__ + "static/media/Sapphire_Sky.1bac3b82.wav";